export type NotificationCount = {
  unseen: number
  unread: number
  total: number
}

export enum CLUB_NOTIFICATION_TYPE {
  COMMENT = 'COMMENT',
  LIKE = 'LIKE',
  DRIPPING = 'DRIPPING',
  REPLY = 'REPLY'
}

export enum ROLE {
  CREATOR = 'CREATOR',
  CONSUMER = 'CONSUMER'
}

export enum CONTEXT {
  CLUB = 'CLUB',
  PLATFORM = 'PLATFORM'
}

export type Notification = {
  content: string
  metadata: {
    context: string
    destiny: string
    membershipName: string
    productName: string
    messageKey: string
    notificationType: string
    picture: string
    senderId: string
    titleKey: string
    type: CLUB_NOTIFICATION_TYPE
    traceId: string
    url: string
    userName: string
  }
  read: boolean
  seen: boolean
  time: string
  title: string
}

export type NotificationList = {
  nextToken?: string
  notifications: Notification[]
}

export type NotificationsParams = {
  language: string
  role: string
  context: string
  nextToken?: string
}

export type CountParams = {
  role: string
  context: string
}

export type ReadAllParams = {
  markRead: boolean
  context: string
}
